import React from "react";
import { CallViewsByTenant } from "../../../types/call-views.types";
import { formatNumber } from "../../../utils/formatters";

interface TenantsTableProps {
  data: CallViewsByTenant[];
}

export const TenantsTable: React.FC<TenantsTableProps> = ({ data }) => {
  return (
    <div
      className="bg-white rounded-lg border border-neutral-200 p-4"
      data-testid="table-by-tenant"
      role="region"
      aria-label="Przeglądanie naborów wg organizacji"
    >
      <h3 className="text-sm font-semibold text-neutral-900 mb-1">
        Przeglądanie wg organizacji
      </h3>
      <p className="text-xs text-neutral-500 mb-3">
        Sortowane wg sumy odsłon (malejąco). Pełne dane dostępne w eksporcie CSV.
      </p>

      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-xs font-medium text-neutral-500 uppercase border-b border-neutral-200">
              <th scope="col" className="py-2 pr-3">Organizacja</th>
              <th scope="col" className="py-2 pr-3 text-right">Suma</th>
              <th scope="col" className="py-2 pr-3 text-right">Web lista</th>
              <th scope="col" className="py-2 pr-3 text-right">Web detal</th>
              <th scope="col" className="py-2 pr-3 text-right">API lista</th>
              <th scope="col" className="py-2 pr-3 text-right">API detal</th>
              <th scope="col" className="py-2 pr-3 text-right">Email detal</th>
              <th scope="col" className="py-2 pr-3 text-right">Dni aktywne</th>
              <th scope="col" className="py-2 text-right">Aktywni użytkownicy</th>
            </tr>
          </thead>
          <tbody>
            {data.map((t, index) => (
              <tr
                key={t.tenantId}
                className="border-b border-neutral-50 last:border-0"
                data-testid={`by-tenant-row-${index}`}
              >
                <td
                  className="py-2 pr-3 text-neutral-900 truncate max-w-[220px]"
                  title={t.tenantName}
                >
                  {t.tenantName || "—"}
                </td>
                <td className="py-2 pr-3 text-right font-medium text-neutral-900 tabular-nums">
                  {formatNumber(t.total)}
                </td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(t.web_list)}</td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(t.web_detail)}</td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(t.api_list)}</td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(t.api_detail)}</td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(t.email_detail)}</td>
                <td className="py-2 pr-3 text-right text-neutral-700 tabular-nums">{formatNumber(t.activeDays)}</td>
                <td className="py-2 text-right text-neutral-700 tabular-nums">{formatNumber(t.activeUsers)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TenantsTable;
